<template>
    <div class="buy-now">
        <div class="buy-now__image">
            <img class="show-desktop" src="@/assets/images/tickets/mobile-screen.png" />
            <img class="show-mobile" src="@/assets/images/tickets/mobile-screen-mb.png" />
        </div>
        <div class="buy-now__content">
            <h2 class="buy-now__title">
                {{ getTranslatedText("green certificate") }} 
            </h2>
            <p class="buy-now__description">
                {{
                    getTranslatedText(
                        "the green certificate you purchase is your contribution to the “oasis park”; o! millionaire’s environmental green project in oman."
                    )
                }}
            </p>
            <div class="buy-now__description-highlight">
                <p>
                    {{
                        getTranslatedText(
                            "each green certificate has a unique code which is your entry for the raffle draw and the grand prize match 7 numbers draw."
                        )
                    }}
                </p>
            </div>
            <p class="buy-now__description">
                {{
                    getTranslatedText(
                        "if you buy one green certificate, you will have one entry to both draws. however, you will have two or more entries in the raffle draw if you buy two or more - and two or three more chances to win!"
                    )
                }}
            </p>
            <div class="buy-now__footer">
                <div class="buy-now__action">
                    <div class="buy-now__action-info">
                        <div class="buy-now__action-info-price">
                            <span class="highlight">{{
                                getTranslatedText(currencyCode)
                            }}</span>
                            <span>{{ formatLocalePrice(2.5) }}</span>
                        </div>
                        <span class="buy-now__action-info-des">{{
                            getTranslatedText("per green certificate")
                        }}</span>
                    </div>
                    <div class="buy-now__action-select-tickets">
                        <SelectQuantity
                            @onChangeTotalPrice="onChangeTotalPrice"
                            @updateBlock="updateBlock"
                        />
                        <ButtonCustom
                            classBtn="buy-now__btn-action"
                            classOption="btn-radius"
                            typeBtn="primary"
                            type="primary"
                            text="next"
                            :isLoading="isLoadingBtn"
                            @onClickButton="onNextTickets"
                        />
                    </div>
                </div>
                <div class="buy-now__box-total">
                    <span class="buy-now__box-total__title"
                        >{{ getTranslatedText("total:") }}
                    </span>
                    <span class="buy-now__box-total__total">
                        {{getTranslatedText(currencyCode)}}
                        <span>{{formatLocalePrice(totalPrice)}}</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="buy-now__background"></div>
    </div>
</template>

<script>
import LanguageMixin from "@/mixins/language/language-mixin";
import BuyNowMixin from "@/mixins/buy-now/buy-now-mixin";
import ButtonCustom from "@/components/common/button";
import SelectQuantity from "@/components/common/select-quantity/SelectQuantity";

import { renderLocalePrice } from "@/components/common/utils";

const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
    mixins: [LanguageMixin, BuyNowMixin],
    components: { ButtonCustom, SelectQuantity },
    data() {
        return {
            currencyCode: CURRENCY_CODE,
            isLoadingBtn: false,
        };
    },
    methods: {
        onNextTickets() {
            localStorage.setItem("list_block", JSON.stringify(this.listBlock));
            this.$router.push("/tickets");
        },

        // func common
        formatLocalePrice(number) {
            return renderLocalePrice(number);
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/buy-now/buy-now.scss" />
